import http from '@/http'

const PATH = '/metrics'

export default {
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listMetrics (params) {
        try {
            const response = await http.get(PATH, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listTypes (params) {
        try {
            const response = await http.get(`${PATH}/types`, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listCharts (params) {
        try {
            const response = await http.get(`${PATH}/charts`, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
